// China is a special case — its "country code" comes from the hostname
// TODO: reuse in comparison app
const isHostnameContainsCC = () => {
    return window.location.hostname.toLowerCase().endsWith('cn');
};
const getBodyLanguageCode = () => {
    var _a;
    return ((_a = document.body.getAttribute('locale').split('_')[0]) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) || '';
};
const getBodyCountryCode = () => {
    var _a;
    return ((_a = document.body.getAttribute('locale').split('_')[1]) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) || '';
};
const formatToLocaleString = (amount, locale) => {
    return new Intl.NumberFormat(locale).format(amount);
};
const transformLocaleToBCP47LanguageTag = (locale) => {
    const ERROR_MESSAGE = 'Invalid locale format';
    if (!/^[a-z]{2}-[A-Z]{2}$/.test(locale)) {
        throw new Error(ERROR_MESSAGE);
    }
    const [languageCode] = /^[a-z]{2}/.exec(locale);
    const [countryCode] = /[A-Z]{2}$/.exec(locale);
    if (!languageCode || !countryCode) {
        throw new Error(ERROR_MESSAGE);
    }
    return `${languageCode}-${countryCode}`;
};

export { getBodyLanguageCode as a, formatToLocaleString as f, getBodyCountryCode as g, isHostnameContainsCC as i, transformLocaleToBCP47LanguageTag as t };
